import { useQuery } from "@tanstack/react-query";
import { InternalDBOverview } from "../utils/models";
import { getErrorMessage } from "../utils/utilities";

import dbService from "../services/dbService";

interface InternalDBState {
    refetch: () => void;
    overview: InternalDBOverview;
    loading: boolean;
    error: boolean;
    lastUpdated: number | null;
}

const initialInternalDBOverview = {
    acceptedReports: 0,
    approvedReports: 0,
    completedProjects: 0,
    pendingApprovalReports: 0,
    projectsByInspectionType: [],
    recentProjects: [],
    rejectedReports: 0,
    riskRating: [],
    totalActiveProjectsInDivision: 0,
    totalExternalUsers: 0,
    totalFacilities: 0,
    totalInActiveProjectsInDivision: 0,
    totalInternalUsers: 0,
    totalOrganisations: 0,
    totalPendingProjectsInDivision: 0,
    totalProjectsInDivision: 0,
    totalProjectsawaitingApproval: 0,
    totalReportsGenerated: 0,
    totalUsers: 0,
    totalUsersInDivision: 0,
};

const useInternalDashboard = (): InternalDBState => {
    const { data, dataUpdatedAt, error, isFetching, refetch } = useQuery({
        queryKey: ['internal-user-details'],
        queryFn: () => dbService.getInternalDashboard(),
        initialData: initialInternalDBOverview,
    });

    return {
        overview: data,
        loading: isFetching,
        error: error ? getErrorMessage(error) : '',
        lastUpdated: dataUpdatedAt,
        refetch,
    };
};
 
export default useInternalDashboard;